module.exports = __webpack_public_path__ + "static/media/img10.bde31f64.png";